// ProfileFormUI.tsx
import { Box, Grid, InputLabel, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface ProfileFormUIProps {
  description: string;
  email: string;
  onDescriptionChange: (value: string) => void;
  onEmailChange: (value: string) => void;
  phone: number | string;
  onPhoneChange: (value: string) => void;
}

const ProfileFormUI: React.FC<ProfileFormUIProps> = ({
  description,
  email,
  onDescriptionChange,
  onEmailChange,
  phone,
  onPhoneChange,
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>
        {t("Profilo aziendale")}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12} sx={{ minWidth: 0 }}>
          <InputLabel required sx={{ mb: 1 }}>
            {t("Descrivi cosa fa la tua azienda")}
          </InputLabel>
          <TextField
            multiline
            rows={8}
            fullWidth
            value={description}
            onChange={(e) => onDescriptionChange(e.target.value)}
            InputProps={{
              sx: {
                "& textarea": {
                  minWidth: "100%", // ensures the textarea takes the full width of its container
                },
              },
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel required sx={{ mb: 1 }}>
            {t("Aggiungi il tuo indirizzo email che i clienti possono utilizzare per contattarti")}
          </InputLabel>
          <TextField
            fullWidth
            type="email"
            value={email}
            onChange={(e) => onEmailChange(e.target.value)}
          />
          <InputLabel required sx={{ mb: 1 }}>
            {t("Aggiungi il tuo numero di telefono")}
          </InputLabel>
          <TextField
            fullWidth
            type="text"
            value={phone}
            onChange={(e) => onPhoneChange(e.target.value)}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default React.memo(ProfileFormUI);
